import useHomeEstimationNavigation, {
  HomeEditReasons,
  HomeEstimationPages,
} from '@/app/pages/home-estimations/useHomeEstimationNavigation'
import { Card, Icon, Text } from '@/components'
import clsx from 'clsx'

export default function HomeEstimatationCard({
  redirectUrl,
}: {
  redirectUrl?: string
}) {
  const homeEstimationNavigation = useHomeEstimationNavigation()

  const onClick = () => {
    homeEstimationNavigation.push(
      HomeEstimationPages.Home,
      HomeEditReasons.Confirmation,
      redirectUrl,
    )
  }

  return (
    <Card className="hover:cursor-pointer" onClick={onClick}>
      <div className="flex flex-row w-full items-center gap-1">
        <div
          className={clsx(
            'mr-2 p-1.5 flex justify-center self-start rounded-lg',
            'bg-blue-100 text-blue-500 w-8 h-8',
          )}
        >
          <Icon name="Home" size={20} />
        </div>
        <div className="flex flex-col gap-1 flex-1">
          <Text>Home estimations</Text>
          <Text variant="body2" className="text-sm">
            Share your home information to help us provide the most accurate
            savings.
          </Text>
        </div>
        <div className="self-center text-themed-grey-400">
          <Icon name="ChevronRight" size={20} />
        </div>
      </div>
    </Card>
  )
}
